import { render, staticRenderFns } from "./MesurePlugin.vue?vue&type=template&id=77850cf4&scoped=true"
import script from "./MesurePlugin.vue?vue&type=script&lang=ts"
export * from "./MesurePlugin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77850cf4",
  null
  
)

export default component.exports